var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 51,
    viewBox: "0 0 68 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M12.0499 19.1027L1.25 32.104V50.2478H66.0493V2.03711L58.7918 14.2194L51.6495 13.193L45.5728 28.7344L36.0496 19.1027L24.0594 30.5488L12.0499 19.1027Z",
    fill: "url(#paint0_linear_3861_4135)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76855 31.5856L9.59569 22.0098C11.0943 20.1763 13.8489 20.0389 15.5225 21.7142L21.3737 27.5711C22.9361 29.135 25.4709 29.135 27.0333 27.5711L32.8498 21.749C34.5358 20.0613 37.3149 20.2152 38.8043 22.0787L40.8631 24.6548C42.8431 27.1322 46.7809 26.4303 47.7829 23.4213L50.2812 15.9189C50.9033 14.0508 52.7924 12.9133 54.7346 13.2373L55.7584 13.4081C57.3801 13.6786 59.0022 12.9293 59.8475 11.5191L65.5311 2.03711",
    stroke: "#22C55E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7901 2.3478L64.9815 1.77739C65.5348 1.67849 66.0609 2.0549 66.146 2.61051L66.6423 5.85377",
    stroke: "#22C55E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3861_4135",
    x1: 33.6497,
    y1: 17.0706,
    x2: 33.6497,
    y2: 50.2478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22C55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22C55E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpGraph);
export default __webpack_public_path__ + "static/media/upGraph.22f7fe089085811488362c929e8fa94c.svg";
export { ForwardRef as ReactComponent };